import { render, staticRenderFns } from "./MakeAccreditationItem.vue?vue&type=template&id=05b400d6&scoped=true&"
import script from "./MakeAccreditationItem.vue?vue&type=script&lang=js&"
export * from "./MakeAccreditationItem.vue?vue&type=script&lang=js&"
import style0 from "./MakeAccreditationItem.vue?vue&type=style&index=0&id=05b400d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b400d6",
  null
  
)

export default component.exports